import { useEffect, useMemo, useState} from "react";
import { Form } from "reactstrap";
import { APIMS } from "../../../../../../config/apims";
import Modal from "react-bootstrap/Modal";
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import "../../../../../../index.css";
import "../../../../../../assets/css/module-ui.css";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFloppyDisk,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

const schoolFields = [
  {
    name: "school_code",
    label: "Kode Sekolah",
    
  },
  {
    name: "school_name",
    label: "Nama Sekolah",
  },
  {
    name: "edu_stage",
    label: "Jenjang Pendidikan",
  },
  {
    name: "npsn",
    label: "NPSN",
  },
  {
    name: "nss",
    label: "NSS",
  },
  {
    name: "akreditasi",
    label: "Akreditasi",
  },
  {
    name: "province",
    label: "Provinsi",
    placeholder: "Masukkan provinsi",
  },
  {
    name: "district",
    label: "Kota/Kabupaten",
  },
  {
    name: "village",
    label: "Desa/Kelurahan",
  },
  {
    name: "address",
    label: "Alamat",
  },
  {
    name: "postal_code",
    label: "Kode Pos",
  },
 
  {
    name: "phone",
    label: "No. Telepon",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
  },
  {
    name: "school_logo",
    label: "Logo Sekolah",
  },
  // {
  //   name: "website",
  //   label: "Website",
  //   placeholder:
  //     "Masukkan alamat website",
  // },

  // {
  //   name: "footer_school_name",
  //   label: "Nama Footer Sekolah",
  //   placeholder:
  //     "Masukkan nama footer sekolah",
  // },
 
];

const initialForm = {
  ysb_branch_id: "",
  school_name: "",
  school_code: "",
  npsn: "",
  province: "",
  district: "",
  subdistrict: "",
  address: "",
  postal_code: "",
  edu_stage: "",
  phone: "",
  website: "",
  email: "",
  school_logo: "",
  nss: "",
  village: "",
  footer_school_name: "",
  akreditasi: "",
};

const safeValue = (value) =>
  value ?? "";

export default function ModalSekolahUpdate(
  props
) {
  const token =
    localStorage.getItem("token");

  const [getData, setGetData] =
    useState([]);

  const [form, setForm] =
    useState(initialForm);

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type":
          "application/json",
      },
    }),
    [token]
  );

  useEffect(() => {
    const getBranches = async () => {
      try {
        const response = await APIMS.get(
          "/api/branches?page=1&limit=1000&ascending=0&search=",
          fetchParams
        );

        setGetData(
          response?.data?.data || []
        );
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error.response?.data
              ?.message ||
            "Gagal memuat data cabang",
        });
      }
    };

    getBranches();
  }, [fetchParams]);

  useEffect(() => {
    setForm({
      ysb_branch_id: safeValue(
        props?.dataUpdate
          ?.ysb_branch_id
      ),
      school_name: safeValue(
        props?.dataUpdate?.school_name
      ),
      school_code: safeValue(
        props?.dataUpdate?.school_code
      ),
      npsn: safeValue(
        props?.dataUpdate?.npsn
      ),
      province: safeValue(
        props?.dataUpdate?.province
      ),
      district: safeValue(
        props?.dataUpdate?.district
      ),
      subdistrict: safeValue(
        props?.dataUpdate?.subdistrict
      ),
      address: safeValue(
        props?.dataUpdate?.address
      ),
      postal_code: safeValue(
        props?.dataUpdate?.postal_code
      ),
      edu_stage: safeValue(
        props?.dataUpdate?.edu_stage
      ),
      phone: safeValue(
        props?.dataUpdate?.phone
      ),
      website: safeValue(
        props?.dataUpdate?.website
      ),
      email: safeValue(
        props?.dataUpdate?.email
      ),
      school_logo: safeValue(
        props?.dataUpdate?.school_logo
      ),
      nss: safeValue(
        props?.dataUpdate?.nss
      ),
      village: safeValue(
        props?.dataUpdate?.village
      ),
      footer_school_name: safeValue(
        props?.dataUpdate
          ?.footer_school_name
      ),
      akreditasi: safeValue(
        props?.dataUpdate?.akreditasi
      ),
    });
  }, [props?.dataUpdate]);

  const handleChange = (event) => {
    const { name, value } =
      event.target;

    setForm((previousForm) => ({
      ...previousForm,
      [name]: value,
    }));
  };

  const handleSubmit = useMutation(
    async (event) => {
      event.preventDefault();
      setIsSubmitting(true);

      try {
        const response =
          await APIMS.put(
            `/api/schools/${props.id}`,
            {
              ysb_branch_id:
                form.ysb_branch_id,
              school_name:
                form.school_name,
              school_code:
                form.school_code,
              npsn: form.npsn,
              province:
                form.province,
              district:
                form.district,
              subdistrict:
                form.subdistrict,
              address: form.address,
              postal_code:
                form.postal_code,
              edu_stage:
                form.edu_stage,
              phone: form.phone,
              website: form.website,
              email: form.email,
              school_logo:
                form.school_logo,
              nss: form.nss,
              village: form.village,
              footer_school_name:
                form.footer_school_name,
              akreditasi:
                form.akreditasi,
            },
            fetchParams
          );

        if (response?.status === 200) {
          ToastSuccess.fire({
            icon: "success",
            title:
              response.data.message,
          });

          props.GetResponseData();
          props.onHide();
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title:
            error.response?.data
              ?.message ||
            "Gagal memperbarui data",
        });
      } finally {
        setIsSubmitting(false);
      }
    }
  );

  return (
    <Modal
      {...props}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog sims-modal-dialog-lg"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-update-sekolah"
    >
      <div className="sims-modal-header">
        <div>
          <h5
            id="modal-update-sekolah"
            className="sims-modal-title"
          >
            Update Sekolah
          </h5>
        </div>

        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          aria-label="Tutup modal"
          disabled={isSubmitting}
        >
          <FontAwesomeIcon
            icon={faXmark}
          />
        </button>
      </div>

      <Form onSubmit={(event) => handleSubmit.mutate(event)}>
        <div className="sims-modal-body sims-modal-body-lg">
          <div className="sims-form-grid">
            <div className="sims-form-group sims-form-span-2">
              <label
                className="sims-form-label"
                htmlFor="ysb_branch_id_update"
              >
                Pilih Cabang
              </label>

              <select
                id="ysb_branch_id_update"
                className="sims-form-select"
                name="ysb_branch_id"
                value={
                  form.ysb_branch_id
                }
                onChange={handleChange}
                disabled={isSubmitting}
              >
                <option value="">
                  Pilih cabang...
                </option>

                {getData.map(
                  (branch, index) => (
                    <option
                      key={
                        branch?.id ||
                        branch?.branch_code ||
                        index
                      }
                      value={branch?.branch_code}
                    >
                      {branch?.branch_name}
                    </option>
                  )
                )}
              </select>
            </div>

            {schoolFields.map(
              (field, index) => (
                <div
                  className="sims-form-group"
                  key={field.name}
                >
                  <label
                    className="sims-form-label"
                    htmlFor={`${field.name}_update`}
                  >
                    {field.label}
                  </label>

                  <input
                    id={`${field.name}_update`}
                    className="sims-form-input"
                    autoComplete="off"
                    type={
                      field.type ||
                      "text"
                    }
                    name={field.name}
                    value={
                      form[field.name]
                    }
                    onChange={
                      handleChange
                    }
                    placeholder={
                      field.placeholder
                    }
                    disabled={
                      isSubmitting
                    }
                  />
                </div>
              )
            )}
          </div>
        </div>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                Memperbarui...
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />
                Perbarui
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}